import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.scss']
})
export class ContentListComponent implements OnInit {

    @Input() title: string;
    @Input() titleTable: any;
    @Input() list: any;
    @Input() modulo: string;

    @Output() clickCreate = new EventEmitter();
    @Output() clickDelete = new EventEmitter();
    @Output() clickUpdate = new EventEmitter();
    @Output() clickDetail = new EventEmitter();
    @Output() clickDeleteTrash = new EventEmitter();

    search = '';
    orderBy = '';
    reverse = false;
    check: any = [];
    numPage = 10;
    pages = 1;

    constructor() { }

    ngOnInit() {
    }

    create() {
        this.clickCreate.emit('create');
    }

    delete(data) {
        this.clickDelete.emit(data);
    }

    order(data) {
        this.reverse = (this.orderBy === data) ? !this.reverse : false;
        this.orderBy = data;
    }

    update(data) {
        this.clickUpdate.emit(data);
    }

    detail(data) {
        this.clickDetail.emit(data);
    }

    checkAll(event) {
        this.check = [];
        this.list.map((element) => {
            if (event.target.checked) {
                this.check.push(element.id);
                element.check = true;
            } else {
                element.check = false;
            }
        });
    }

    checkAcept(event, id) {
        if (event.target.checked) {
            this.check.push(id);
        } else {
            const value = this.check.map((d) => {
                return d;
            }).indexOf(id);
            this.check.splice(value, 1);
        }
    }

    deleteTrash() {
        this.clickDeleteTrash.emit(this.check);
    }

}
